import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Select from 'react-select';

const InscriptionModal = ({ show, onHide, onSuccess }) => {
    const [formData, setFormData] = useState({
        nom: '',
        prenoms: '',
        tel: '',
        email: '',
        profession: '',
        type_financement: '',
        code_promo: '',
        code_partenaire: '',
        diplome: '',
        formation: '',
        entreprise: ''
    });

    const TextAvecVoirPlus = () => {
        const [voirPlus, setVoirPlus] = useState(false);

        const texteComplet = `Dans le cadre de ses prestations, INOVACT procède au traitement de données personnelles intéressant 
      le Client ainsi que des participants aux sessions de formations tels que figurant dans le bulletin d’inscription. 
      En tout état de cause INOVACT ne collecte des informations personnelles relatives à l’utilisateur que pour le 
      besoin des services proposés. L’utilisateur fournit ces informations en toute connaissance de cause, 
      notamment lorsqu’il procède par lui-même à leur saisie. Conformément aux dispositions de la loi 2017-20 portant 
      code du numérique en République du Bénin, tout utilisateur dispose d’un droit d’accès, de rectification et d’opposition 
      aux données personnelles le concernant, en effectuant sa demande écrite et signée, accompagnée d’une copie du titre 
      d’identité avec signature du titulaire de la pièce, en précisant l’adresse à laquelle la réponse doit être envoyée. 
      Aucune information personalisée de l'utilisateur n'est publiée à l'insu de l'utilisateur, échangée, transférée, 
      cédée ou vendue sur un support quelconque à des tiers. Les données à caractère personnel collectées seront traitées 
      exclusivement à des fins d'exécution des présentes conditions de vente et également en vue d'actions commerciales, 
      afin de proposer au Client ou aux participants qui y consentent des services analogues à ceux objets du présent 
      contrat par INOVACT. Les données à caractère personnel collectées peuvent être communiquées à des tiers auxquels 
      il serait nécessaire de les transmettre en exécution des prestations convenues et notamment aux organismes de financement, 
      afin de permettre la prise en charge des formations objets des présentes. Conformément à la loi précitée, 
      vous pouvez exercer vos droits d'accès, d'opposition, de rectification et de suppression auprès de la direction de INOVACT.`;

        const texteAbrege = `Dans le cadre de ses prestations, INOVACT procède au traitement de données personnelles intéressant 
      le Client ainsi que des participants aux sessions de formations. Conformément à la loi 2017-20 portant code du numérique 
      en République du Bénin, tout utilisateur dispose d'un droit d'accès, de rectification et d'opposition aux données 
      personnelles le concernant...`;

        return (
            <div className="text-justify mb-3">
                <small>
                    {voirPlus ? texteComplet : texteAbrege}
                    <button
                        type="button"
                        className="btn btn-link p-0 ml-1"
                        onClick={() => setVoirPlus(!voirPlus)}
                        style={{
                            fontSize: 'inherit',
                            textDecoration: 'underline',
                            border: 'none',
                            background: 'none',
                            color: '#007bff',
                            cursor: 'pointer'
                        }}
                    >
                        {voirPlus ? 'Voir moins' : 'Voir plus'}
                    </button>
                </small>
            </div>
        );
    };

    // État pour les formations disponibles
    const [formations, setFormations] = useState([]);
    const [loadingFormations, setLoadingFormations] = useState(true);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (show) {
            fetchFormations();
        }
    }, [show]);

    const fetchFormations = async () => {
        try {
            setLoadingFormations(true);
            const response = await fetch(process.env.REACT_APP_HOTE + '/liste-formation/');
            if (response.ok) {
                const data = await response.json();

                // Filtrer seulement les formations actives
                const formationsActives = data.filter(formation =>
                    formation.statut === "actif" ||
                    (formation.statut && formation.statut.toLowerCase() === "actif")
                );

                setFormations(formationsActives);
            } else {
                console.error('Erreur lors de la récupération des formations');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setLoadingFormations(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleFormationChange = (selectedOption) => {
        setFormData({
            ...formData,
            formation: selectedOption ? selectedOption.value : ''
        });
    };

    const handlePhoneChange = (value) => {
        if (value && !value.startsWith('+')) {
            setPhoneError('Le numéro doit commencer par un indicatif pays (ex: +229)');
        } else {
            setPhoneError('');
            setFormData({
                ...formData,
                tel: value,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation
        if (!formData.tel || !formData.tel.startsWith('+')) {
            setPhoneError('Veuillez entrer un numéro de téléphone valide avec indicatif pays');
            return;
        }

        if (!formData.formation) {
            setMessage('Veuillez sélectionner une formation');
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + '/enregistrer-inscription/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    nom: formData.nom,
                    prenoms: formData.prenoms,
                    telephone: formData.tel,
                    email: formData.email,
                    profession: formData.profession,
                    type_financement: formData.type_financement,
                    code_promo: formData.code_promo,
                    code_partenaire: formData.code_partenaire,
                    diplome: formData.diplome,
                    entreprise: formData.entreprise,
                    reference: formData.formation
                }),
            });

            const result = await response.json();

            if (response.ok) {
                setMessage('Inscription réussie !');
                setSuccess(true);
                if (onSuccess) {
                    onSuccess();
                }

                // Réinitialiser le formulaire après 2 secondes
                setTimeout(() => {
                    setFormData({
                        nom: '',
                        prenoms: '',
                        tel: '',
                        email: '',
                        profession: '',
                        type_financement: '',
                        code_promo: '',
                        code_partenaire: '',
                        diplome: '',
                        formation: ''
                    });
                    setSuccess(false);
                    onHide();
                }, 2000);
            } else {
                setMessage(result.error || 'Erreur lors de l\'inscription');
            }
        } catch (error) {
            console.error('Error:', error);
            setMessage('Erreur de connexion au serveur');
        } finally {
            setLoading(false);
        }
    };

    const formatFormationPeriod = (periode) => {
        if (!periode || periode === '[]' || periode === '""' || periode === "''") {
            return "À la demande";
        }

        try {
            if (typeof periode === 'string') {
                const cleanedPeriode = periode.replace(/'/g, '"');
                const dates = JSON.parse(cleanedPeriode);

                if (Array.isArray(dates) && dates.length > 0) {
                    return dates.map(date => {
                        try {
                            const dateObj = new Date(date);
                            return dateObj.toLocaleDateString('fr-FR', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            });
                        } catch (e) {
                            return date;
                        }
                    }).join(', ');
                }
            }
        } catch (error) {
            // Si ce n'est pas un JSON valide, retourner la chaîne telle quelle
            return periode;
        }

        return periode;
    };

    // Préparer les options pour le select des formations
    const formationOptions = formations.map(formation => ({
        value: formation.reference,
        label: `${formation.nom} - ${formatFormationPeriod(formation.periode)}${formData.type_financement === "Entreprise" ? ` - ${formation.prix.toLocaleString()} FCFA` : ` - ${formation.prix_particulier.toLocaleString()} FCFA`}`
    }));

    const handleClose = () => {
        setFormData({
            nom: '',
            prenoms: '',
            tel: '',
            email: '',
            profession: '',
            type_financement: '',
            code_promo: '',
            code_partenaire: '',
            diplome: '',
            formation: ''
        });
        setMessage('');
        setPhoneError('');
        setSuccess(false);
        onHide();
    };

    return (
        <Modal show={show} onHide={handleClose} size="lg" centered>
            <Modal.Header>
                <Modal.Title>
                    <i className="fa fa-user-plus mr-2"></i>
                    Nouvelle inscription
                </Modal.Title>
            </Modal.Header>

            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    {success ? (
                        <div className="text-center p-4">
                            <div className="mb-4">
                                <i className="fa fa-check-circle text-success fa-5x"></i>
                            </div>
                            <h4 className="text-success">Inscription réussie !</h4>
                            <p>L'inscription a été enregistrée avec succès.</p>
                            <p>Redirection en cours...</p>
                        </div>
                    ) : (
                        <>
                            {message && (
                                <div className={`alert ${message.includes('réussie') ? 'alert-success' : 'alert-danger'} mb-3`}>
                                    {message}
                                </div>
                            )}

                            <div className="row">
                                {/* Ligne 1 - Nom et Prénom */}
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Nom <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Votre nom"
                                            required
                                            name="nom"
                                            value={formData.nom}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Prénom(s) <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Vos prénoms"
                                            required
                                            name="prenoms"
                                            value={formData.prenoms}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </div>

                                {/* Ligne 2 - Téléphone et Email */}
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Téléphone <span className="text-danger">*</span>
                                        </Form.Label>
                                        <PhoneInput
                                            international
                                            defaultCountry="BJ"
                                            value={formData.tel}
                                            onChange={handlePhoneChange}
                                            className="form-control p-0 border-0"
                                            required
                                            inputProps={{
                                                name: 'tel',
                                                required: true,
                                                className: 'form-control'
                                            }}
                                        />
                                        {phoneError && (
                                            <div className="text-danger small mt-1">{phoneError}</div>
                                        )}
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Email <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Votre email"
                                            required
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </div>

                                {/* Ligne 3 - Profession, Diplôme, Financement */}
                                <div className="col-md-4 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Profession <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Votre profession"
                                            required
                                            name="profession"
                                            value={formData.profession}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Diplôme <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            required
                                            name="diplome"
                                            value={formData.diplome}
                                            onChange={handleChange}
                                            className='custom-select'
                                        >
                                            <option value="">Sélectionnez</option>
                                            <option value="BAC">BAC</option>
                                            <option value="BTS">BTS</option>
                                            <option value="Licence">Licence</option>
                                            <option value="Master1">Master1</option>
                                            <option value="Master2">Master2</option>
                                            <option value="Doctorat">Doctorat</option>
                                            <option value="Ingénieur">Ingénieur</option>
                                            <option value="Autres">Autres</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Type de financement <span className="text-danger">*</span>
                                        </Form.Label>
                                        <Form.Select
                                            required
                                            name="type_financement"
                                            value={formData.type_financement}
                                            onChange={handleChange}
                                            className='custom-select'
                                        >
                                            <option value="">Sélectionnez</option>
                                            <option value="Particulier">Particulier</option>
                                            <option value="Entreprise">Entreprise</option>
                                        </Form.Select>
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Code promo
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Code promo"
                                            // required
                                            name="code_promo"
                                            value={formData.code_promo}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Code partenaire
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Code partenaire"
                                            // required
                                            name="code_partenaire"
                                            value={formData.code_partenaire}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </div>
                                {formData.type_financement === "Entreprise" &&
                                    <div className="col-12 mb-3">
                                        <Form.Group>
                                            <Form.Label>
                                                Entreprise <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Votre entreprise"
                                                required
                                                name="entreprise"
                                                value={formData.entreprise}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </div>
                                }

                                {/* Ligne 4 - Sélection de formation */}
                                <div className="col-12 mb-3">
                                    <Form.Group>
                                        <Form.Label>
                                            Formation souhaitée <span className="text-danger">*</span>
                                        </Form.Label>
                                        {loadingFormations ? (
                                            <div className="form-control" style={{ padding: '0.375rem 0.75rem' }}>
                                                <small className="text-muted">Chargement des formations...</small>
                                            </div>
                                        ) : (
                                            <Select
                                                options={formationOptions}
                                                value={formationOptions.find(option => option.value === formData.formation)}
                                                onChange={handleFormationChange}
                                                placeholder="Sélectionnez une formation"
                                                isClearable
                                                required
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            />
                                        )}
                                    </Form.Group>
                                </div>
                            </div>

                            {/* <TextAvecVoirPlus/> */}
                            <div className='text-left ml-1'>
                                <a className='text-left text-success' style={{
                                    textDecoration: 'underline',
                                    textDecorationColor: '#1c09ecff',
                                    transition: 'all 0.3s ease'
                                }}
                                    href='https://inovact.com/politique-confidentialite.html'
                                    onMouseEnter={(e) => e.target.style.textDecoration = 'underline dotted'}
                                    onMouseLeave={(e) => e.target.style.textDecoration = 'underline'}>
                                    Politique de confidentialité
                                </a>
                            </div>
                        </>
                    )}
                </Modal.Body>

                {!success && (
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Annuler
                        </Button>
                        <Button variant="success" type="submit" disabled={loading}>
                            {loading ? 'Enregistrement...' : 'Enregistrer'}
                        </Button>
                    </Modal.Footer>
                )}
            </Form>
        </Modal>
    );
};

export default InscriptionModal;